var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDerivativesFee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1A7A7",
    strokeDasharray: "3.5 3.5",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M5 16h22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DF3030",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m5 11 5.353 5.736a1 1 0 0 0 1.392.068l3.024-2.66a1 1 0 0 1 1.394.07l8.337 8.982"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1A7A7",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M24 5h4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerivativesFee);
export default __webpack_public_path__ + "static/media/derivativesFee.c2dbde346341136c2316ef81cc7bce27.svg";
export { ForwardRef as ReactComponent };